import { Injectable } from '@angular/core';
import { HttpInterceptorService } from '../http-interceptor/http-interceptor.service';
import { baseID } from '../../defaults';
import { GlobalFunctions } from '../global-functions/global-functions.service';
import { RolesService } from '../roles/roles.service';
import { DialogService } from '../dialog/dialog.service';
import { UserType } from 'src/app/user-roles';
import { map, Observable } from 'rxjs';
import { UserService } from 'src/app/lib';
import { TranslateService } from '@ngx-translate/core';
import { HttpParams } from '@angular/common/http';
import { ToastService } from '../../shared/services/toast/toast.service';

@Injectable()
export class CompanyService {
  companies: any = [];
  company: any;

  constructor(
    private _http: HttpInterceptorService,
    private userService: UserService,
    private gf: GlobalFunctions,
    private rolesService: RolesService,
    private dialog: DialogService,
    private toastService: ToastService,
    private translate: TranslateService
  ) {}

  clear() {
    this.companies = [];
    this.company = null;
  }

  getAll(): Promise<any> {
    return new Promise((resolve) => {
      this._http.get('Companies/GetCompaniesForOperator').subscribe(
        (companies) => {
          this.companies = companies.datas;
          resolve(companies.datas);
        },
        (err) => {
          resolve([]);
        }
      );
    });
  }
  getAllCompanies(query: string) {
    return this._http.get('Companies').pipe(
      map((result) => {
        let companies = result?.datas || [];

        if (typeof query === 'string' && query.length) {
          companies = companies.filter((company) => {
            if (company.PK_CompanyID && company.PK_CompanyID.toString().indexOf(query.toString()) > -1) {
              return company;
            }
            if (company.Name && company.Name.toLowerCase().indexOf(query.toLowerCase()) > -1) {
              return company;
            }
            if (company.OwnerEmail && company.OwnerEmail.toLowerCase().indexOf(query.toLowerCase()) > -1) {
              return company;
            }
            if (company.OwnerFirstName && company.OwnerFirstName.toLowerCase().indexOf(query.toLowerCase()) > -1) {
              return company;
            }
            if (company.OwnerLastName && company.OwnerLastName.toString().indexOf(query) > -1) {
              return company;
            }
            if (company.Email && company.Email.toString().toLowerCase().indexOf(query.toLowerCase()) > -1) {
              return company;
            }
            if (
              company.InvoiceEmail &&
              company.InvoiceEmail.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
            ) {
              return company;
            }

            if (company.OwnerFirstName && company.OwnerLastName) {
              const fullName = company.OwnerFirstName + ' ' + company.OwnerLastName;
              const newVal = query.replace(/\s\s+/g, ' ');
              if (fullName.toLowerCase().indexOf(newVal.toLowerCase()) > -1) {
                return company;
              }
            }
          });
        }

        return companies;
      })
    );
  }
  getPaginatedSearch(search: string, includeInactive = false, startIndex = 0, take = 10) {
    const params = {
      Search: search,
      IncludeInactive: includeInactive,
      StartIndex: startIndex,
      Take: take
    };
    return this._http.get(`Companies/paginated-search`, { params: new HttpParams({ fromObject: params }) });
  }
  generateInvoices(companyID) {
    return this._http.get(`Invoices/GenerateInvoicesForACompany/${companyID}`);
  }
  getInvoiceAgreements(companyID, startIndex = 0, limit = 20) {
    return this._http.get(`Companies/UsersCompanyPaysFor/${companyID}/${startIndex}/${limit}`);
  }
  getAllUnverified(paginationStart: number = 0): Observable<any> {
    return this._http.get(`Companies/NeedToBeVerified/${paginationStart}/10`);
  }
  // @TODO: Clean this up a bit
  get(reload?): Promise<any> {
    return new Promise((resolve, reject) => {
      this.userService.getUser().subscribe((user) => {
        if (!reload && this.company && this.company.OwnedByCustomerID === user.PK_CustomerID) {
          resolve(this.company);
        } else {
          this._http.get('Companies/GetCompanyOwnedByCustomer/' + user.PK_CustomerID).subscribe(
            (company) => {
              if (!company || (company.errorName && company.errorName === 'notFoundError')) {
                reject(this.translate.instant('NO_COMPANY_REGISTERED'));
              } else {
                this.company = company;
                if (this.company.OwnedByCustomerID === user.PK_CustomerID) {
                  this.company.OwnedByLoggedInUser = true;
                }
                resolve(this.company);
              }
            },
            (err) => {
              if (this.rolesService.hasHighlevelAccess(UserType.Admin)) {
                resolve({ PK_CompanyID: 0 });
              } else {
                if (err.errorName === 'notFoundError') {
                  reject(this.translate.instant('NO_COMPANY_REGISTERED'));
                } else {
                  reject(this.translate.instant('SOMETHING_WENT_WRONG'));
                }
              }
            }
          );
        }
      });
    });
  }
  getPaymentMethods(companyID): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get('PaymentMethods/ForCompany/' + companyID + '/false').subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
  getSettlements(companyID, index, limit, from, to): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
        .get('CompanySettlements/ForACompany/' + companyID + '/' + index + '/' + limit + '/' + from + '/' + to)
        .subscribe(
          (res) => {
            if (res) {
              resolve(res);
            } else {
              resolve([]); //Empty for no methods
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  getSettlement(settlementID): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get('CompanySettlements/' + settlementID).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
  createBraintreeCustomer(braintreeObj, customer, currency, companyID): Promise<any> {
    return new Promise((resolve, reject) => {
      var newCustomer = {
        FirstName: customer.FirstName,
        LastName: customer.LastName,
        CustomerID: customer.PK_CustomerID,
        Email: customer.Email, //Remove this when the prod-api is updated to accept CustomerID instead
        NonceFromClient: braintreeObj.nonce,
        Identifyer: braintreeObj.details.lastTwo || braintreeObj.details.email,
        PaymentType: braintreeObj.details.cardType || 'PayPal',
        Currency: currency,
        FK_CompanyID: companyID
      };

      this._http.post('PaymentMethods/AddPaymentMethodFromBraintree', newCustomer).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
  setDefaultPayment(paymentMethodID): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.put('PaymentMethods/SetDefault/' + paymentMethodID, {}).subscribe(
        (res) => {
          resolve(true);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
  getSingle(companyID): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.company && this.company.PK_CompanyID === parseInt(companyID)) {
        resolve(this.company);
      } else {
        this._http.get('Companies/' + companyID).subscribe(
          (company) => {
            this.company = company;
            resolve(company);
          },
          (err) => {
            if (err.errorName === 'notFoundError') {
              resolve(null);
            } else {
              reject(this.translate.instant('SOMETHING_WENT_WRONG'));
            }
          }
        );
      }
    });
  }
  searchOrgNumber(text, countryID): Promise<any> {
    const params = new HttpParams({ fromObject: { text, countryID } });

    return new Promise((resolve, reject) => {
      this._http.get('Companies/by-org-info', { params }).subscribe({
        next: (res) => {
          if (Array.isArray(res)) {
            resolve(res);
          } else {
            reject('Unknown error');
          }
        },
        error: (err) => {
          if (err.status === 204) {
            reject('notfound');
          } else {
            reject(err.errorName);
          }
        }
      });
    });
  }
  ownedByCustomer(customerID): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get('Companies/GetCompanyOwnedByCustomer/' + customerID).subscribe(
        (company) => {
          resolve(company);
        },
        (err) => {
          if (err.errorName === 'notFoundError') {
            resolve(null);
          } else {
            reject(this.translate.instant('SOMETHING_WENT_WRONG'));
          }
        }
      );
    });
  }
  update(company): Promise<any> {
    return new Promise((resolve) => {
      this.userService.getUser().subscribe((user) => {
        company.ModifiedByUserID = user.FK_UserID;
        this._http.put('Companies', company).subscribe(
          (res) => {
            resolve(true);
          },
          (err) => {
            this.toastService.error(err);
            resolve(false);
          }
        );
      });
    });
  }
  delete(company): Promise<any> {
    return new Promise((resolve) => {
      this.dialog
        .prompt(this.translate.instant('CONFIRM_DELETE_COMPANY'), null, this.translate.instant('DELETE'))
        .subscribe((doDelete) => {
          if (doDelete) {
            this._http.delete('Companies/' + company.PK_CompanyID).subscribe(
              (res) => {
                resolve(true);
              },
              (err) => {
                this.toastService.error(err);
                resolve(false);
              }
            );
          } else {
            resolve(false);
          }
        });
    });
  }

  create(company): Promise<any> {
    return new Promise((resolve) => {
      this.userService.getUser().subscribe((user) => {
        company.ModifiedByUserID = user.FK_UserID;
        company.CreatedByUserID = user.FK_UserID;
        company.FK_BaseID = baseID;
        company.PaymentDay = 1;
        company.CreatedOn = this.gf.getDateAsUTC();
        company.isActive = true;
        company.Keys = this.gf.guid4();

        this._http.post('Companies', company).subscribe(
          (res) => {
            //this.company = res;
            if (res.datas) {
              resolve(res.datas);
              // this.authService.refreshMenus();
            } else {
              this.toastService.error();
              resolve(false);
            }
          },
          (err) => {
            this.toastService.error(err);
            resolve(false);
          }
        );
      });
    });
  }
  createByCustomer(company, ownedByCustomer): Promise<any> {
    //FIX: This is a weird way to do this. Fix later
    return new Promise((resolve) => {
      let companyToAdd = {
        FK_BaseID: baseID,
        OwnedByCustomerID: ownedByCustomer.PK_CustomerID,
        FK_CountryID: company.FK_CountryID,
        Name: company.Name,
        Phone: '',
        Email: ownedByCustomer.Email,
        Address: company.Address,
        CreatedOn: this.gf.getDateAsUTC(),
        UTC: this.gf.getDateAsUTC(),
        isActive: true,
        isPublic: true,
        Keys: this.gf.guid4()
      };
      this.create(companyToAdd).then((res) => {
        resolve(res);
      });
    });
  }
  init(): Promise<any> {
    //Initializes new company
    return new Promise((resolve) => {
      this.userService.getUser().subscribe((user) => {
        let company = {
          FK_BaseID: baseID,
          OwnedByCustomerID: user.PK_CustomerID,
          ModifiedByUserID: user.FK_UserID,
          CreatedByUserID: user.FK_UserID,
          CreatedOn: this.gf.getDateAsUTC(),
          UTC: this.gf.getDateAsUTC(),
          Keys: this.gf.guid4(),
          isActive: true,
          isPublic: true
        };
        resolve(company);
      });
    });
  }

  getSingleCompanyPayment(paymentID: number) {
    return this._http.get(`CompanyPayments/${paymentID}`);
  }
}
